import { Auth0Provider } from '@auth0/auth0-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App.tsx';

// Check if Auth0 is enabled
const isAuth0Enabled =
  import.meta.env.MODE !== 'pentest' && import.meta.env.VITE_AUTH0_ENABLED === 'true';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAuth0Enabled ? (
      <Auth0Provider 
        domain={import.meta.env.VITE_AUTH0_DOMAIN} 
        clientId={import.meta.env.VITE_AUTH0_CLIENT_ID} 
        authorizationParams={{ 
          redirect_uri: `${window.location.origin}/`,
        }}
        cacheLocation='localstorage'
        onRedirectCallback={(appState) => {
          window.history.replaceState(
            {},
            document.title,
            appState?.returnTo || window.location.pathname
          );
        }}
      >
        <App />
      </Auth0Provider>
    ) : (
      <App />
    )}
  </StrictMode>
);
